export const PROMOTE_MODERATOR_REQUEST = 'user/PROMOTE_MODERATOR_REQUEST';
export const PROMOTE_MODERATOR_SUCCESS = 'user/PROMOTE_MODERATOR_SUCCESS';
export const PROMOTE_MODERATOR_FAILURE = 'user/PROMOTE_MODERATOR_FAILURE';

export const promoteModeratorRequest = () => ({ type: PROMOTE_MODERATOR_REQUEST });
export const promoteModeratorSuccess = payload => ({ type: PROMOTE_MODERATOR_SUCCESS, payload });
export const promoteModeratorFailure = () => ({ type: PROMOTE_MODERATOR_FAILURE });

export const promoteModerator = userId => (dispatch, getState, { request }) => {
  dispatch(promoteModeratorRequest());
  const promise = request.patch(`/_api/users/${userId}/permissions`, {
    role: 'moderator',
    moderate: ['all'],
  });
  return promise
    .then(user => dispatch(promoteModeratorSuccess(user)))
    .catch(() => dispatch(promoteModeratorFailure()))
    .then(() => promise);
};



// WEBPACK FOOTER //
// ./app/actions/promote-moderator.js